import { render, staticRenderFns } from "./MtsAlacakFormWizard.vue?vue&type=template&id=080b9c76"
import script from "./MtsAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./MtsAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports